// src/components/CustomerSummary/CustomerSummary.jsx
// ============================================================================
// BLOCK CS.PAGE.0 — Customer Summary page
// ----------------------------------------------------------------------------
// Composition layer only.
// - State + actions live in useCustomerSummaryController
// - Panels are pure renderers
// ============================================================================

import React from 'react';

import ErrorDialog from './dialogs/ErrorDialog.jsx';
import useCustomerSummaryController from './hooks/useCustomerSummaryController.js';
import HeaderPanel from './panels/HeaderPanel.jsx';
import SectionsPanel from './panels/SectionsPanel.jsx';

export default function CustomerSummary() {
  const c = useCustomerSummaryController();

  const handleStartDateChange = c.setStartDateUi;
  const handleEndDateChange = c.setEndDateUi;
  const handleStartDateCommitIso = c.setStartDateIso;
  const handleEndDateCommitIso = c.setEndDateIso;
  const handleFacilityChange = c.setFacilityName;
  const handleGenerate = c.generateAll;
  const handleSelectSave = c.loadSave;
  const handleSaveAs = c.saveAs;
  const handleUpdate = c.updateSelectedSave;
  const handleDelete = c.deleteSelectedSave;
  const handleLoad = c.loadSave;
  const handleToggleExpand = c.toggleExpanded;
  const handleToggleLock = c.toggleLock;
  const handleAuto = c.autoPopulateSection;
  const handleClear = c.clearSection;
  const handleMoveUp = c.moveUp;
  const handleMoveDown = c.moveDown;
  const handleChangeText = c.setSectionText;
  const handleSetTableColumnWidths = c.setTableColumnWidths;
  const handleCloseError = () => c.setError(null);

  return (
    <>
      <HeaderPanel
        facilities={c.facilities}
        loadingFacilities={c.loadingFacilities}
        facilityName={c.facilityName}
        startDate={c.startDateUi}
        endDate={c.endDateUi}
        onStartDateChange={handleStartDateChange}
        onEndDateChange={handleEndDateChange}
        onStartDateCommitIso={handleStartDateCommitIso}
        onEndDateCommitIso={handleEndDateCommitIso}
        canGenerate={c.canGenerate}
        generating={c.generating}
        saving={c.saving}
        onFacilityChange={handleFacilityChange}
        onGenerate={handleGenerate}
        // saved layouts
        saves={c.saves}
        selectedSave={c.selectedSave}
        onSelectSave={handleSelectSave}
        onSaveAs={handleSaveAs}
        onUpdate={handleUpdate}
        onDelete={handleDelete}
        // primary action becomes Load when a layout is selected
        onLoad={handleLoad}
        canLoad={Boolean(c.selectedSave)}
      />

      <SectionsPanel
        order={c.order}
        sections={c.sections}
        locks={c.locks}
        expanded={c.expanded}
        onToggleExpand={handleToggleExpand}
        onToggleLock={handleToggleLock}
        onAuto={handleAuto}
        onClear={handleClear}
        onMoveUp={handleMoveUp}
        onMoveDown={handleMoveDown}
        onChangeText={handleChangeText}
        uiPrefs={c.uiPrefs}
        onSetTableColumnWidths={handleSetTableColumnWidths}
      />

      <ErrorDialog error={c.error} onClose={handleCloseError} />
    </>
  );
}
